export default __webpack_public_path__ + "static/media/oil-gas.f88e4d4d.png";